// @ts-check
import 'Styles/commonComponents/settings/descriptionTextSetting.scss';
import { observer } from 'mobx-react';
import React from "react";
import SettingsBlockItem from 'Components/Common/Settings/SettingsBlockItem';

/**
 * @param {{
 * className?: string,
 * text: string,
 * isTitle?: boolean
 * }} props 
 * @returns {React.JSX.Element}
 */
const DescriptionTextSetting = (props) => {
    return (
        <SettingsBlockItem
            className={'description-text-setting ' + (props.className ? props.className : '')}>
            <div className={'description-text-setting-text ' + (props.isTitle ? 'description-text-normal' : '')}>
                {props.text}
            </div>
        </SettingsBlockItem>
    )
};

export default observer(DescriptionTextSetting);